import { ReactElement } from 'react';

import {
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
} from '@mui/material';
import {
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
} from 'react-hook-form';

export type CheckboxWithLabelProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<MuiCheckboxProps, 'checked'> & {
  ControllerProps: Omit<ControllerProps<TFieldValues, TName>, 'render'>;
  FormControlLabelProps: Omit<FormControlLabelProps, 'control'>;
};

export const CheckboxWithLabel = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  ControllerProps,
  FormControlLabelProps,
  ...props
}: CheckboxWithLabelProps<TFieldValues, TName>): ReactElement => {
  return (
    <Controller
      {...ControllerProps}
      render={({ field: { onChange, ...field } }) => (
        <FormControlLabel
          control={
            <MuiCheckbox
              {...props}
              {...field}
              onChange={(event, checked) => {
                onChange(event);
                props.onChange && props.onChange(event, checked);
              }}
              checked={field.value as boolean}
            />
          }
          {...FormControlLabelProps}
        />
      )}
    />
  );
};
